import(/* webpackMode: "eager", webpackExports: ["DonationsShowcase"] */ "/var/www/light_of_empire_front/widgets/DonationsShowcase/DonationsShowcase.tsx");
